import {RemoteGetRequestProtocolPdf} from 'data/usecases';
import {GetRequestProtocolPdf} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRequestProtocolPdf = (): GetRequestProtocolPdf =>
	new RemoteGetRequestProtocolPdf(
		makeBFFApiUrl(RefundFlowEndPoints.requestProtocolPdf),
		makeAuthorizeHttpClientDecorator(),
	);
